import { Box, Container, useMediaQuery, useTheme } from "@mui/material";

import React from "react";
import Headings from "../../common/headings/headings";
import ProfileCard from "../../common/bits/profile-card/profile-card";

export default function About() {
  const theme = useTheme();
  // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
  const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <div className="ui-padding--36"></div>
        <Headings heading="About"></Headings>
        <div className="ui-padding--24"></div>
        <Box className="mai" display="flex" flexDirection={ltsm ? "column" : "row"} justifyContent="center" alignItems="center">
          <Box order={ltsm ? 3 : 1} p={2} flex={"65%"}>
            <h1 className="ui-typo--h2">Who's this guy?</h1>
            <Box p={2}></Box>
            {/* brings websites from nothing into existence, fully developed */}
            <p className="ui-typo--h5 ui-font-weight--normal app-summary">
              <span className="ui-typo--h4 ">
                <i> Bharath Kishore</i>
              </span>
              &ensp;is a web developer based in the garden city of India
              <i>
                <b>"Bengaluru"</b>
              </i>
              <i> , He enjoy's creating things that live on the internet. With over 7+ years of experience, he has built a diverse range of projects — from intuitive frontends to robust backend APIs — focusing on performance, clean architecture, and real-world impact. He is passionate about open-source technologies, continuously learning, and contributing to the developer community while exploring modern tools and frameworks to build meaningful digital experiences. </i>
            </p>
          </Box>
          <Box order={2} display="flex" flex={"10%"}></Box>
          <Box order={ltsm ? 1 : 3} display="flex" my={1} flex={"35%"} mt={ltsm ? 8 : 0} height={ltsm ? "100%" : 256} maxHeight={ltsm ? "60%" : "40%"}>
            {/* <img src="assets/img/16417.jfif" className="ui-image" alt="" /> */}
            <ProfileCard
              handle="bhrthkshr"
              status="Online"
              contactText="Contact Me"
              avatarUrl="/assets/img/16417.png"
              showUserInfo={false}
              enableTilt={true}
              enableMobileTilt={false}
              onContactClick={() => console.log("Contact clicked")}
              iconUrl="/assets/img/iconpattern.png"
            />
          </Box>
        </Box>
        <div className="ui-padding--24"></div>

        <div className="entry" id="snow2">
          <div></div>
        </div>
      </Container>
    </React.Fragment>
  );
}
